import confetti from "canvas-confetti";

export function burstPositive() {
  confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 }, colors: ["#00E5FF", "#00FF66", "#FFD600", "#AA00FF"] });
}

export function burstGold() {
  const end = Date.now() + 700;
  (function frame() {
    confetti({ particleCount: 6, angle: 60, spread: 55, origin: { x: 0 }, colors: ["#FFD700", "#FFC107", "#FFEB3B"] });
    confetti({ particleCount: 6, angle: 120, spread: 55, origin: { x: 1 }, colors: ["#FFD700", "#FFC107", "#FFEB3B"] });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

export function burstReward() {
  confetti({ particleCount: 120, spread: 100, startVelocity: 40, origin: { y: 0.5 }, colors: ["#AA00FF", "#FF007F", "#00E5FF"] });
}
